export enum LabelBadge28Type {
  ticket = 'ticket',
  refund = 'refund',
  solid = 'solid',
  line = 'line',
}
